/**
 * Module-level singleton that tracks whether an NMP animation (break/link/exchange)
 * is currently in progress. BottomPanel subscribes to this instead of scanning the
 * full manipulative array, reducing button re-evaluations from ~10+ per animation
 * to exactly 2 (start + end).
 */
export var nmpAnimationTicker = {
    isAnimating: false,
    _listeners: new Set(),
    setAnimating: function (val) {
        if (this.isAnimating === val)
            return;
        this.isAnimating = val;
        this._listeners.forEach(function (fn) { return fn(); });
    },
    subscribe: function (fn) {
        var _this = this;
        this._listeners.add(fn);
        return function () { return _this._listeners.delete(fn); };
    },
};
